import React from 'react';
import AuthShell from './AuthShell';
import LoginTab from './Tabs/LoginTab';

const Logins = () => {
  return (
    <AuthShell>
      <LoginTab />
    </AuthShell>
  );
};

export default Logins;
